import React, { useEffect, useState } from 'react';
import api from '../api';
import NewsCard from './NewsCard';
import './FeaturedNews.css';

export default function FutureNews({ title = 'आने वाली खबरें' }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const fetchLiveFeatured = async () => {
      try {
        setLoading(true);
        const res = await api.get('/api/news/featured');
        const liveItems = (res.data && res.data.success) ? res.data.data || [] : [];
        if (mounted) setItems(liveItems);
      } catch (err) {
        console.warn('Failed to load live featured', err.message || err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchLiveFeatured();
    return () => { mounted = false; };
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section className="featured-db-section">
      <div className="container">
        <h2 className="section-title">{title}</h2>
        <div className="featured-db-grid">
          {items.map((n) => (
            <NewsCard key={n._id || n.title} news={n} featured />
          ))}
        </div>
      </div>
    </section>
  );
}
